import { Component, Input, OnInit } from '@angular/core';
import { AuditFilter, AuditType, AuditOwnerGroup, SMEApprover, DateType, AuditStatus } from '../../audit.model';
import {FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuditService } from '../../audit.service';
import { map, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'iaud-audit-filter-form',
  templateUrl: './audit-filter-form.component.html',
  styleUrls: ['./audit-filter-form.component.scss']
})
export class AuditFilterFormComponent implements OnInit {

  auditFilterForm: FormGroup;
  auditTypes$: Observable<Array<AuditType>>;
  sme$: Observable<Array<SMEApprover>>;
  dateTypes: Array<string> = [DateType.DUE_DATE, DateType.COMPLETION_DATE, DateType.REGISTRATION_DATE];
  status: Array<string> = [AuditStatus.COMPLETED, AuditStatus.DRAFT, AuditStatus.PENDING];
  auditOwnerGroups$: Observable<Array<AuditOwnerGroup>>;

  @Input()
  filter: AuditFilter = {};

  constructor(private formBuilder: FormBuilder,
              private auditService: AuditService) { }

  ngOnInit(): void {
    this.auditFilterForm = this.generateForm();
    this.auditTypes$ = this.auditService.getAuditTypes()
      .pipe(
        map((types: Array<AuditType>) => types.filter(type => type.isActive))
      );
      
    this.sme$ = this.auditService.getSmeApprovers(0);

    this.auditOwnerGroups$ = this.auditService.getAuditOwnerGroups()
      .pipe(
        map((groups: Array<AuditOwnerGroup>) => groups.filter(group => group.isActive))
      );

    this.auditFilterForm.valueChanges
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(values => {
        this.filter.auditTypeId = values.auditTypeId;
        this.filter.dateType  = values.dateType;
        this.filter.status = values.status;
        this.filter.date = values.date;
        this.filter.sme = values.sme;
        this.filter.ownerId = values.ownerId;
        this.filter.external = values.external;
        this.filter.capaCompleted = values.capaCompleted;
        this.filter.capaOverdue = values.capaOverdue;
        this.filter.capaInProgress = values.capaInProgress;
      });
    this.auditFilterForm.get('dateType').valueChanges
      .subscribe(value => {
        if (!value) {
          this.auditFilterForm.get('date').disable();
        } else {
          this.auditFilterForm.get('date').enable();
        }
      });
  }

  generateForm(): FormGroup {
    return this.formBuilder.group({
      auditTypeId: [this.filter.auditTypeId ? this.filter.auditTypeId : []],
      status: [this.filter.status ? this.filter.status : null],
      dateType: [this.filter.dateType ? this.filter.dateType : null],
      date: new FormControl({value: this.filter.date, disabled: !this.filter.dateType}),
      sme: [this.filter.sme ? this.filter.sme : null],
      ownerId: [this.filter.ownerId ? this.filter.ownerId : null],
      external: [this.filter.external ? this.filter.external : null],
      capaCompleted: [this.filter.capaCompleted ? this.filter.capaCompleted : null],
      capaOverdue: [this.filter.capaOverdue ? this.filter.capaOverdue : null],
      capaInProgress: [this.filter.capaInProgress ? this.filter.capaInProgress : null]
    });
  }


}
